// Test IDs & constants
export const TESTIDS = {
  navHome: "nav-home",
  navProducts: "nav-products",
  navWhy: "nav-why",
  navReviews: "nav-reviews",
  navContact: "nav-contact",
  navOrder: "nav-order-btn",
  hamburgerBtn: "hamburger-btn",
  mobileMenu: "mobile-menu",
  heroOrderBtn: "hero-order-btn",
  heroViewProducts: "hero-view-products-btn",
  productHoneyBuy: "product-honey-buy-btn",
  productGheeBuy: "product-ghee-buy-btn",
  ctaOrderBtn: "cta-order-btn",
  ctaContactBtn: "cta-contact-btn",
  floatingWhatsapp: "floating-whatsapp-btn",
  mobileStickyOrder: "mobile-sticky-order-btn",
  contactForm: "contact-form",
  contactName: "contact-name-input",
  contactPhone: "contact-phone-input",
  contactEmail: "contact-email-input",
  contactMessage: "contact-message-input",
  contactSubmit: "contact-submit-btn",
  contactSuccess: "contact-success-msg",
  faqAccordion: "faq-accordion",
};

// Brand config
export const BRAND = {
  name: "Rudrima",
  tagline: "Pure. Natural. Healthy.",
  whatsapp: "919889573628", // no + or spaces for wa.me
  whatsappDisplay: "+91 98895 73628",
  email: "rudrimaa@gmail.com",
  company: "JOSWBS PRIVATE LIMITED",
  addressLines: ["E-2/125, Vinamra Khand, Gomtinagar,", "Lucknow, Uttar Pradesh – 226010"],
  addressInline: "E-2/125, Vinamra Khand, Gomtinagar, Lucknow, Uttar Pradesh – 226010",
  instagram: "#",
  facebook: "#",
  waMessage: "Hi Rudrima! I'm interested in ordering your organic products. Please share the details.",
};

// Assets (uploaded)
export const ASSETS = {
  logo: "https://customer-assets.emergentagent.com/job_5f99645d-ca56-4335-a923-beea78991a5f/artifacts/f8k04k7i_WhatsApp%20Image%202026-07-04%20at%202.31.56%20PM.jpeg",
  honeyLight: "https://customer-assets.emergentagent.com/job_5f99645d-ca56-4335-a923-beea78991a5f/artifacts/vlum7lg2_WhatsApp%20Image%202026-07-04%20at%203.53.20%20PM.jpeg",
  honeyForest: "https://customer-assets.emergentagent.com/job_5f99645d-ca56-4335-a923-beea78991a5f/artifacts/v33cy6mt_WhatsApp%20Image%202026-07-04%20at%203.58.31%20PM.jpeg",
  gheeSweets: "https://customer-assets.emergentagent.com/job_5f99645d-ca56-4335-a923-beea78991a5f/artifacts/hspbfj2m_WhatsApp%20Image%202026-07-04%20at%203.46.59%20PM%20%286%29.jpeg",
  gheeRoti: "https://customer-assets.emergentagent.com/job_5f99645d-ca56-4335-a923-beea78991a5f/artifacts/018xejen_WhatsApp%20Image%202026-07-04%20at%203.46.59%20PM%20%285%29.jpeg",
};

export const waUrl = (msg) =>
  `https://wa.me/${BRAND.whatsapp}?text=${encodeURIComponent(msg || BRAND.waMessage)}`;
